import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import trayUpload from "@iconify/icons-mdi/tray-upload";
import { toast } from "react-toastify";
import { getData, uploadFile, postData, putData } from "../../../webService/webservice.js";
import "../../../styles/Auth/customer.css";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";

const AddCustomerForm = ({
    isEditMode = false,
    customerId = null,
    onSuccess,
    onCancel,
    initialStoreId,
    initialPhoneNumber = "",
}) => {
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const localStoreId = JSON.parse(localStorage.getItem("storeIds") || "[]")[0] || "";
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [customerImage, setCustomerImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [customer, setCustomer] = useState({});

    const getCleanPhone = (val) => {
        if (!val) return "";
        const digits = val.replace(/\D/g, "").slice(0, 10);
        return digits || val;
    };

    const [formData, setFormData] = useState({
        storeId: initialStoreId || localStoreId,
        name: "",
        email: "",
        gender: "",
        phoneNumber: getCleanPhone(initialPhoneNumber),
        country: "India",
        city: "",
        state: "",
        pincode: "",
        age: "",
        aboutUs: "",
        customerNote: "",
        customerImageObject: "",
        dateOfBirth: "",
        aniversaryDate: ""
    });

    useEffect(() => {
        if (!isEditMode && initialPhoneNumber) {
            const clean = getCleanPhone(initialPhoneNumber);
            setFormData(prev => ({
                ...prev,
                phoneNumber: clean
            }));
        }
    }, [initialPhoneNumber, isEditMode]);
    const maleImage = "/assets/male-sample.png";
    const femaleImage = "/assets/female.jpeg";
    const defaultImage = "/assets/mdi--user.svg";

    const validateForm = () => {
        const phoneRegex = /^[0-9]{10}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^[a-zA-Z\s]+$/;
        const pincodeRegex = /^[0-9]{6}$/;

        if (!formData.name.trim()) return "Name is required";
        if (!formData.phoneNumber || !phoneRegex.test(formData.phoneNumber)) {
            return "Mobile number must be 10 digits";
        }
        if (!formData.gender.trim()) return "Gender is required";
        // if (formData.email && !emailRegex.test(formData.email)) {
        //     return "Invalid email format";
        // }
        // if (formData.age && (formData.age < 1 || formData.age > 120)) {
        //     return "Age must be between 1 and 120";
        // }
        // if (formData.country && !nameRegex.test(formData.country)) {
        //     return "Country should only contain letters";
        // }
        // if (formData.state && !nameRegex.test(formData.state)) {
        //     return "State should only contain letters";
        // }
        // if (formData.city && !nameRegex.test(formData.city)) {
        //     return "City should only contain letters";
        // }
        // if (formData.pincode && !pincodeRegex.test(formData.pincode)) {
        //     return "Pincode must be 6 digits";
        // }
        return null;
    };

    // Load existing customer in Edit mode
    useEffect(() => {
        if (isEditMode && customerId) {
            const fetchCustomer = async () => {
                try {
                    const token = localStorage.getItem("Token");
                    const response = await getData(`customers/customer/${customerId}`, token);
                    const data = Array.isArray(response.data) ? response.data[0] : response.data;

                    setFormData({
                        name: data?.name || "",
                        phoneNumber: data?.phoneNumber || "",
                        email: data?.email || "",
                        age: data?.age || "",
                        gender: data?.gender || "",
                        city: data?.city || "",
                        country: data?.country || "",
                        state: data?.state || "",
                        pincode: data?.pincode || "",
                        storeId: data?.storeId?._id || data?.storeId || "",
                        aboutUs: data?.aboutUs || "",
                        customerNote: data?.customerNote || "",
                        customerImageObject: data?.customerImageObject || "",
                        dateOfBirth: data?.dateOfBirth ? new Date(data.dateOfBirth).toISOString().split('T')[0] : "",
                        aniversaryDate: data?.aniversaryDate ? new Date(data.aniversaryDate).toISOString().split('T')[0] : ""
                    });

                    setPreviewUrl(
                        data?.customerImageObject?.uri
                            ? `${process.env.REACT_APP_API_URL}${data.customerImageObject.uri}`
                            : "/assets/mdi--user.svg"
                    );
                } catch (error) {
                    console.error("Error fetching customer:", error);
                }
            };
            fetchCustomer();
        }
    }, [isEditMode, customerId]);

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const token = localStorage.getItem("Token");
            const res = await getData(
                "stores/stores",
                { page, limit: 10, search: inputValue },
                token
            );
            const results = res?.data?.results || [];
            const options = results.map(store => ({ value: store._id, label: store.storeName }));
            return { options, hasMore: results.length === 10, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    useEffect(() => {
        const fetchStoreLabel = async (id) => {
            try {
                const token = localStorage.getItem("Token");
                const res = await getData(`stores/store/${id}`, {}, token);
                if (res?.data) {
                    setStores([{ value: res.data._id, label: res.data.storeName }]);
                }
            } catch (err) {
                console.error("Failed to fetch store label in Customer Form", err);
            }
        };

        if (initialStoreId) {
            setFormData(prev => ({ ...prev, storeId: initialStoreId }));
            fetchStoreLabel(initialStoreId);
        } else if (localStoreId) {
            setFormData(prev => ({ ...prev, storeId: localStoreId }));
            fetchStoreLabel(localStoreId);
        }
    }, [initialStoreId, localStoreId]);

    // Submit Form
    const handleSubmit = async (e) => {
        e.preventDefault();

        const error = validateForm();
        if (error) {
            toast.error(error);
            return;
        }

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");
            let customerImageObject = formData.customerImageObject;

            if (customerImage && userId) {
                const uploadResult = await uploadFile(
                    `files/upload/${userId}`,
                    customerImage
                );
                if (uploadResult?.status === 200) {
                    customerImageObject = uploadResult?.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }

            const customerData = {
                ...formData,
                customerImageObject,
                dateOfBirth: formData.dateOfBirth || null,
                aniversaryDate: formData.aniversaryDate || null
            };

            let response;
            if (isEditMode) {
                response = await putData(
                    `customers/customer/${customerId}`,
                    customerData,
                    token
                );
            } else {
                response = await postData("customers/", customerData, token);
            }

            if (response?.success === false) {
                throw new Error(response.message || "Failed to save customer");
            }

            toast.success(
                response.message || (isEditMode ? "Customer updated" : "Customer added")
            );
            onSuccess?.(response.data);
        } catch (error) {

            console.error("Customer Save Error:", error);

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Error saving customer";

            toast.error(errorMessage);
        }
    };

    // Handle Input Change
    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleCancel = () => {
        onCancel();
    };

    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra & Nagar Haveli and Daman & Diu",
        "Delhi",
        "Jammu & Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ];

    return (
        <form className="pos-customer-form" onSubmit={handleSubmit}>
            <h3>{isEditMode ? "Edit Customer" : "Add Customer"}</h3>
            <div className="customer-form-row">
                <div className="customer-form-group-image">
                    <div className="image-upload-wrapper">
                        <div className="image-placeholder">
                            <img
                                src={
                                    previewUrl
                                        ? previewUrl
                                        : formData.customerImageObject?.uri
                                            ? `${process.env.REACT_APP_API_URL}${formData.customerImageObject.uri}`
                                            : "/assets/mdi--user.svg"
                                }
                                alt="Preview"
                                className="round-image"
                            />
                        </div>
                    </div>
                    <div className="upload-icon-container">
                        <label htmlFor="customerImage" className="upload-icon-btn">
                            Upload Image
                            <Icon icon={trayUpload} width="24" height="24" />
                            <input
                                type="file"
                                id="customerImage"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file && file.size > 1024 * 1024) {
                                        toast.error("Image size exceeds the maximum allowed limit (1 MB).");
                                        e.target.value = "";
                                        return;
                                    }
                                    setCustomerImage(file);
                                    setPreviewUrl(URL.createObjectURL(file));
                                }}
                            />
                        </label>
                    </div>
                </div>
            </div>

            {/* Name & Store */}
            <div className="customer-form-row">
                <div className="customer-form-group">
                    <label>Name<span className="required">*</span></label>
                    <input
                        type="text"
                        className="category-input"
                        placeholder="Enter customer name"
                        value={formData.name}
                        onChange={(e) => {
                            if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                handleChange("name", e.target.value);
                            }
                        }}
                    />
                </div>

                <div className="customer-form-group">
                    <label className="input-label">Branch Name</label>
                    <StoreMultiSelect
                        value={stores}
                        onChange={(val) => {
                            setStores(val);
                            setFormData(prev => ({ ...prev, storeId: val && val.length > 0 ? val[0].value : "" }));
                        }}
                        loadStores={loadStores}
                        loggedInRole={role}
                        assignedStoreIds={adminStoreIds}
                        isMulti={false}
                    />
                </div>

                <div className="customer-form-group">
                    <label>Mobile Number<span className="required">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter Mobile Number"
                        className="category-input"
                        maxLength={10}
                        value={formData.phoneNumber}
                        onChange={(e) => {

                            handleChange("phoneNumber", e.target.value);

                        }}
                    />
                </div>

                <div className="customer-form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        placeholder="Enter Email"
                        className="category-input"
                        value={formData.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                    />
                </div>

                <div className="customer-form-group">
                    <label>Gender<span className="required">*</span></label>
                    <select
                        value={formData.gender}
                        onChange={(e) => handleChange("gender", e.target.value)}
                        className="category-input"
                    >
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="others">Other</option>
                    </select>
                </div>
            </div>

            {/* Other fields */}
            <div className="customer-form-row">
                <div className="customer-form-group">
                    <label>City</label>
                    <input
                        type="text"
                        placeholder="Enter City"
                        className="category-input"
                        value={formData.city}
                        onChange={(e) => {
                            if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                handleChange("city", e.target.value);
                            }
                        }}
                    />
                </div>
                <div className="customer-form-group">
                    <label>Profession</label>
                    <select
                        className="category-input"
                        value={formData.aboutUs}
                        onChange={(e) => handleChange("aboutUs", e.target.value)}
                    >
                        <option value="">Select Option</option>
                        <option value="Doctors">Doctors</option>
                        <option value="Teachers">Teachers</option>
                        <option value="IT">IT</option>
                        <option value="Senior Citizens">Senior Citizens</option>
                        <option value="Government officers">Government Officers</option>
                        <option value="Lawyers">Lawyers</option>
                    </select>
                </div>
            </div>

            {/* Customer Note */}
            <div className="customer-form-row">
                <div className="customer-form-group" style={{ flex: "1 1 100%" }}>
                    <label className="input-label">Customer Note</label>
                    <textarea
                        rows={3}
                        placeholder="Enter Customer Note"
                        className="category-input"
                        style={{ height: "auto", minHeight: "90px", resize: "vertical", paddingTop: "10px", fontSize: "14px" }}
                        value={formData.customerNote}
                        onChange={(e) => handleChange("customerNote", e.target.value)}
                    />
                </div>
            </div>

            {/* DOB & Anniversary */}
            <div className="customer-form-row">
                <div className="customer-form-group">
                    <label>Date of Birth</label>
                    <input
                        type="date"
                        className="category-input"
                        value={formData.dateOfBirth}
                        onChange={(e) => handleChange("dateOfBirth", e.target.value)}
                    />
                </div>
                <div className="customer-form-group">
                    <label>Anniversary Date</label>
                    <input
                        type="date"
                        className="category-input"
                        value={formData.aniversaryDate}
                        onChange={(e) => handleChange("aniversaryDate", e.target.value)}
                    />
                </div>
            </div>

            {/* Buttons */}
            <div className="customer-buttons">
                <button type="submit" className="add-Product-button">
                    {isEditMode ? "Update Customer" : "Add Customer"}
                </button>
                <button type="button" onClick={handleCancel} className="cancel-Product-button">
                    Cancel
                </button>
            </div>
        </form>
    );
};

export default AddCustomerForm;
